import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import MenuHeader from '../components/MenuHeader';
import { useHistory } from 'react-router-dom';
import { Badge, Button, Card, Col, Container, Row } from 'reactstrap';
import Banner1 from '../assets/img/small-banner1.jpg';
import Banner2 from '../assets/img/small-banner2.jpg';
import Banner3 from '../assets/img/small-banner3.jpg';
import Banner4 from '../assets/img/bg-banner4.jpg';
import Banner5 from '../assets/img/bg-banner5.jpg';
import Instagram1 from '../assets/img/instagram1.jpg';
import Instagram2 from '../assets/img/instagram2.jpg';
import Instagram3 from '../assets/img/instagram3.jpg';
import Instagram4 from '../assets/img/instagram4.jpg';
import Instagram5 from '../assets/img/instagram5.jpg';
import Instagram6 from '../assets/img/instagram6.jpg';
import HomeCarousel from '../components/HomeCarousel';
import Footer from '../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories } from '../Redux/actions/categoryActions';
import { getProducts } from '../Redux/actions/productActions';
const instaData = [
	{
		img_src: Instagram1,
	},
	{
		img_src: Instagram2,
	},
	{
		img_src: Instagram3,
	},
	{
		img_src: Instagram4,
	},
	{
		img_src: Instagram5,
	},
	{
		img_src: Instagram6,
	},
];
const HomePage = () => {
	const dispatch = useDispatch();

	const history = useHistory();
	const { allProducts } = useSelector(state => state.products);
	const { allCategories } = useSelector(state => state.category);
	const getAllCategories = () => {
		dispatch(getCategories());
	};
	const getAllProducts = () => {
		dispatch(getProducts());
	};
	useEffect(() => {
		if (!allCategories.length) {
			getAllCategories();
		}
		if (!allProducts.length) {
			getAllProducts();
		}
	}, []);
	return (
		<>
			<Header />
			<MenuHeader />
			<HomeCarousel />
			<Container className='mt-5 px-5' fluid>
				<Row>
					<Col lg='4' md='6'>
						<Card className='banner'>
							<img src={Banner1} alt='Banner1' />
							<div className='banner__content'>
								<Badge>NEW</Badge>
								<h4>
									Nervous Disorder <br /> Tablet
								</h4>
								<Button
									onClick={() => {
										history.push(
											'/shop?Breathing Disorder'
										);
									}}
									className='btn__outline'
								>
									More
								</Button>
							</div>
						</Card>
					</Col>
					<Col lg='4' md='6' className='mt-3 mt-md-0'>
						<Card className='banner'>
							<img src={Banner2} alt='Banner2' />
							<div className='banner__content2'>
								<h4>
									Sleeping <br /> Tablet
								</h4>
								<h5>-10%</h5>
								<Button
									onClick={() => {
										history.push('/shop?Sleeping Pill');
									}}
									className='btn__outline'
								>
									Shop now
								</Button>
							</div>
						</Card>
					</Col>
					<Col lg='4' md='6' className='mt-3 mt-lg-0'>
						<Card className='banner'>
							<img src={Banner3} alt='Banner3' />
							<div className='banner__content3'>
								<h4>
									Norvasc
									<br /> for Blood pressure
								</h4>
								<h5>$44.99</h5>
								<Button
									onClick={() => {
										history.push('/shop?Nervous Disorder');
									}}
									className='btn__outline'
								>
									Shop now
								</Button>
							</div>
						</Card>
					</Col>
				</Row>
				<Row className='mt-5'>
					<Col>
						<Card className='d-flex flex-row secure__card'>
							<i class='fas fa-shield-check'></i>
							<strong>100% Secure delivery</strong>{' '}
							<span className='ml-1'>
								{' '}
								without contacting the courier
							</span>
							{/* <div className='ml-auto'>
								<Button className='btn__outline '>More</Button>
							</div> */}
						</Card>
					</Col>
				</Row>
				<Row className='mt-5'>
					<Col lg='6'>
						<Card className='banner2'>
							<img src={Banner4} alt='Banner4' />
							<div className='banner__content4'>
								<Badge>NEW</Badge>
								<h4>
									Get rid of bacteria <br /> in your home
								</h4>
								<Button
									onClick={() => {
										history.push('/shop?Pain Relief');
									}}
									className='btn__outline'
								>
									More
								</Button>
							</div>
						</Card>
					</Col>
					<Col lg='6' className='mt-3 mt-lg-0'>
						<Card className='banner2'>
							<img src={Banner5} alt='Banner5' />
							<div className='banner__content5'>
								<h4>
									Candid <br /> Whitening Kit
								</h4>
								<h5>-10%</h5>
								<Button
									onClick={() => {
										history.push(
											'/shop?Mens Sexual Health'
										);
									}}
									className='btn__outline'
								>
									Shop now
								</Button>
							</div>
						</Card>
					</Col>
				</Row>
			</Container>
			<Container className='mt-5 bg__primary py-5 px-3 mb-5' fluid>
				<h2 className='review__heading'>Latest reviews</h2>
				<Row className='mt-3'>
					<Col lg='3' md='4' sm='6'>
						<div className='custom__review__card'>
							<p>
								There was a small mistake in the order. In
								return, I got the correct order and I could keep
								the wrong one for myself.
							</p>
							<strong>Esther Howard</strong>
						</div>
					</Col>
					<Col lg='3' md='4' sm='6' className='mt-3 mt-sm-0'>
						<div className='custom__review__card'>
							<p>
								I ordered on Friday evening and on Monday at
								12:30 the package was with me. I have never
								encountered such a fast order processing.
							</p>
							<strong>Albert Flores</strong>
						</div>
					</Col>
					<Col lg='3' md='4' sm='6' className='mt-3 mt-md-0'>
						<div className='custom__review__card'>
							<p>
								I ordered on Friday evening and on Monday at
								12:30 the package was with me. I have never
								encountered such a fast order processing.
							</p>
							<strong>Dianne Russell</strong>
						</div>
					</Col>
					<Col lg='3' md='4' sm='6' className='mt-3 mt-md-0'>
						<div className='custom__review__card'>
							<p>Everything is perfect. I would recommend!</p>
							<strong>Darlene Robertson</strong>
						</div>
					</Col>
				</Row>
			</Container>
			<Container fluid className='px-5 mb-5'>
				<h2 className='follow__us'>Follow on Instagram</h2>
				<Row>
					{instaData.map((data, index) => {
						return (
							<Col
								lg='2'
								md='4'
								sm='6'
								className='mt-3 px-1 position-relative overflow-hidden'
								key={index}
							>
								<img
									src={data.img_src}
									alt='Insta Images'
									className='img-fluid insta__bg'
								/>
								<div className='insta__follow'>
									<i className='fab fa-instagram'></i>
								</div>
							</Col>
						);
					})}
				</Row>
			</Container>
			<Footer />
		</>
	);
};

export default HomePage;
